import htmlParser from 'html-react-parser';
import ResizableImage, { IResizableImage } from 'src/components/moray/ResizeableImage';
import './HighlightBanner.scss';
import MoraySpinnerSmall from './MoraySpinnerSmall';

export interface IHighlightBanner {
  titleText: string | undefined;
  descriptionText?: string;
  textContainerWidth?: '5' | '6' | '7' | '8' | '9' | '10';
  buttonText?: string;
  buttonLink?: string;
  buttonOnClick?(): any;
  secondButtonText?: string;
  secondButtonLink?: string;
  secondButtonOnClick?(): any;
  additionalDescription?: string;
  buttonAriaLabel?: string;
  secondButtonAriaLabel?: string;
  resizableImageProps: IResizableImage;
  reverseTextAlign?: boolean;
  leftTextAlign?: boolean;
  reverseTextColor?: boolean;
  isLoading?: boolean;
  gradient?: 'left' | 'right';
  backgroundClassName?: string;
  containerClassName?: string;
  cardContainerClassNames?: string;
}

const HighlightBanner = ({
  titleText,
  descriptionText,
  textContainerWidth,
  buttonText,
  buttonLink,
  buttonOnClick,
  secondButtonText,
  secondButtonLink,
  secondButtonOnClick,
  additionalDescription,
  buttonAriaLabel,
  secondButtonAriaLabel,
  resizableImageProps,
  reverseTextAlign,
  leftTextAlign,
  reverseTextColor,
  isLoading,
  gradient,
  backgroundClassName,
  containerClassName,
  cardContainerClassNames
}: IHighlightBanner) => (
  <div className="card-img-overlay highlight-banner-container">
    <div
      className={`card-background my-0 ${gradient !== undefined ? `${gradient}-gradient` : ''} ${
        backgroundClassName ?? ''
      }`}
    >
      <ResizableImage {...resizableImageProps} />
    </div>
    <div className="card-foreground ">
      <div className={`container ${containerClassName ?? ''}`}>
        <div className={`d-flex mt-md-n5 my-lg-5 ${reverseTextAlign ? 'flex-row-reverse' : ''}`}>
          <div className={`w-100 w-lg-col-${textContainerWidth ?? '5'} text-container-overflow`}>
            <div
              className={`card material-md-card py-5 ${leftTextAlign ? 'left-text-align' : 'px-md-5'} ${
                cardContainerClassNames ?? ''
              }`}
            >
              <div className="card-body ">
                {descriptionText ? (
                  <h1
                    className={`banner-title h1 ${
                      reverseTextColor ? 'card-body-text-black' : 'card-body-text'
                    } font-weight-semibold`}
                  >
                    {titleText}
                  </h1>
                ) : (
                  <h4
                    className={`h4 ${
                      reverseTextColor ? 'card-body-text-black' : 'card-body-text'
                    } font-weight-semibold`}
                  >
                    {titleText}
                  </h4>
                )}
                <div className="mb-4">
                  <p />
                  <p className={`banner-desc ${reverseTextColor ? 'card-body-text-black' : 'card-body-text'}`}>
                    {htmlParser(descriptionText ?? '')}
                  </p>
                  <p />
                  <p className={`banner-desc ${reverseTextColor ? 'card-body-text-black' : 'card-body-text'}`}>
                    {htmlParser(additionalDescription ?? '')}
                  </p>
                </div>
                {buttonText !== undefined && (
                  <div className="link-group">
                    {isLoading ? (
                      <MoraySpinnerSmall />
                    ) : (
                      <>
                        {buttonLink !== undefined ? (
                          <a
                            href={buttonLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary"
                            tabIndex={0}
                            aria-label={buttonAriaLabel}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                if (buttonOnClick) buttonOnClick();
                              }
                            }}
                          >
                            {buttonText}
                          </a>
                        ) : (
                          <button className="btn btn-primary" aria-label={buttonAriaLabel} onClick={buttonOnClick}>
                            {buttonText}
                          </button>
                        )}
                        {secondButtonText && secondButtonOnClick && (
                          <>
                            {secondButtonLink !== undefined ? (
                              <a
                                href={secondButtonLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary"
                                tabIndex={0}
                                aria-label={secondButtonAriaLabel}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (secondButtonOnClick) secondButtonOnClick();
                                  }
                                }}
                              >
                                {secondButtonText}
                              </a>
                            ) : (
                              <button
                                className="btn btn-primary"
                                aria-label={secondButtonAriaLabel}
                                onClick={secondButtonOnClick}
                              >
                                {secondButtonText}
                              </button>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HighlightBanner;
